export default __webpack_public_path__ + "static/media/leftArrow.7ecb894d.png";